/// <reference types="segment-analytics" />
import * as React from 'react';
import * as segment from '@segment/snippet';
import Me from './me';
import global from './global';
import { privacyOptOutIntegrations } from '~/libs/analytics/utils/options';

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
    _DATADOG_SYNTHETICS_BROWSER?: boolean;
  }
}

const getAnalyticsWriteKey = () => {
  return global.circleci?.config?.analyticsKey;
};

/**
 * Configures Analytics for the current user and enforces Privacy Opt Out.
 * @deprecated use `Analytic` component instead
 * @param me - The current user.
 */
const useAnalytics = (me?: Me) => {
  React.useLayoutEffect(() => {
    const analyticsKey = getAnalyticsWriteKey();
    if (!analyticsKey) return;

    const options = {
      apiKey: analyticsKey,
      // note: the page option is disabled because it's limited to SSR
      // use: trackPage event to explicityle track page impressions
      page: false,
      load: false,
    };

    const snippet =
      process.env.NODE_ENV === 'development'
        ? segment.max(options)
        : segment.min({
            host: 'cci-growth-utils.s3.us-east-2.amazonaws.com/segment',
            ...options,
          });
    if (!window.analytics) {
      eval(snippet);
    }
  }, []);

  // This is useLayoutEffect rather than useEffect because
  // we need our analytics ASAP
  React.useLayoutEffect(() => {
    const analyticsKey = getAnalyticsWriteKey();
    if (!analyticsKey) return;
    if (me) {
      const options = me.privacyOptout
        ? {
            integrations: privacyOptOutIntegrations,
          }
        : {};
      window?.analytics &&
        window.analytics.load &&
        typeof window.analytics.load === 'function' &&
        window.analytics.load(analyticsKey, options);
    }
  }, [me]);
};

export default useAnalytics;
